import React from 'react';
import SectionHeader from '@monorepo/shared/src/components/layout/SectionHeader';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ResourcesList from '@monorepo/shared/src/components/modules/Resources/ResourcesList';
import WithQuery from '@monorepo/shared/src/components/common/WithQuery';
import useProfessionalLearningResourcesStore from 'graph/state/query-hooks/use-professional-learning-resources';
import NoContent from '@monorepo/shared/src/components/common/NoContent';
import makeStyles from '@mui/styles/makeStyles';
import { FONT_GSS_FUTURA_BOLD } from '@monorepo/shared/src/themes/defaultTheme';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import useTrialUserOmitRoutes from 'state/hooks/use-trial-user-omit-routes';

const t = (key: string, options?) => translate('professionalLearning', key, options);

const ProfessionalLearning: React.FC = () => {
  const classes = useStyles();
  const { resources, error, isLoading } = useProfessionalLearningResourcesStore();
  const omitRoutes = useTrialUserOmitRoutes();
  return (
    <>
      <SectionHeader title={t('header')} omitRoutes={omitRoutes} />
      <Box className={classes.root}>
        <Typography className={classes.title} component="h1">
          {t('title')}
        </Typography>
        <WithQuery loading={isLoading} error={error} ErrorComponent={NoContent}>
          <ResourcesList resources={resources} areDisplayingPinToggle={false} />
        </WithQuery>
      </Box>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    marginTop: theme.typography.pxToRem(24),
    padding: `0 ${theme.spacing(24)}`,
  },
  title: {
    fontFamily: FONT_GSS_FUTURA_BOLD,
    padding: '0px 1.1875rem',
    fontSize: theme.typography.pxToRem(32),
    lineHeight: theme.typography.pxToRem(48),
  },
}));

export default ProfessionalLearning;
